// import analytics from '@utils/analytics';
import React from 'react';
import StoreGetDirections from '@components/storelocator/StoreGetDirections';
const StoreSummary = (props) => {
    const { store } = props;
    return (React.createElement("div", { className: "store-page__info row" },
        React.createElement("div", { className: "col-lg-8" },
            React.createElement("h2", { className: "font__title store-name" }, store.name),
            React.createElement(StoreGetDirections, { store: store, className: "button button--secondary full store__summary__directions" }))));
};
export default StoreSummary;
